import { FormEvent, useState } from "react";
import { useAuth } from "@/state/auth";
import { Icon } from "@/components/IconSprite";

const LoginPanel = () => {
  const login = useAuth((state) => state.login);
  const loading = useAuth((state) => state.loading);
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    try {
      await login(username.trim(), password);
      setPassword("");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "48px 24px",
        position: "relative",
        background: "var(--bg-2)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: "radial-gradient(circle at 1px 1px,var(--line-2) 1px,transparent 0)",
          backgroundSize: "22px 22px",
          opacity: 0.45,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: -90,
          left: "50%",
          transform: "translateX(-50%)",
          width: 420,
          height: 220,
          background: "radial-gradient(ellipse,rgba(0,168,80,.16),transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <div style={{ width: "100%", maxWidth: 370, position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 24 }}>
          <div className="mark" style={{ width: 38, height: 38, borderRadius: 12, marginBottom: 14 }}>
            <svg viewBox="0 0 24 24" style={{ width: 20, height: 20 }}>
              <use href="#i-leaf" />
            </svg>
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 680, letterSpacing: "-.028em", margin: "0 0 6px" }}>
            Sante AI Admin
          </h2>
          <p
            style={{
              fontSize: 13,
              color: "var(--ink-3)",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.55,
              maxWidth: 300,
            }}
          >
            Sign in with your administrator credentials to manage the assistant.
          </p>
        </div>

        <div className="card" style={{ boxShadow: "var(--sh-3)" }}>
          <form className="card-b" onSubmit={handleSubmit}>
            <div className="fg">
              <label className="fl">Username</label>
              <input
                className="inp"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                placeholder="admin"
              />
            </div>
            <div className="fg">
              <label className="fl">Password</label>
              <input
                className="inp"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                placeholder="••••••••••••"
              />
            </div>
            {error && (
              <p className="hint err" style={{ marginTop: 0, marginBottom: 12 }}>
                <Icon name="alert" /> {error}
              </p>
            )}
            <button
              type="submit"
              className="btn pri lg"
              style={{ width: "100%", marginTop: 4 }}
              disabled={loading}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>

        <p
          style={{
            fontSize: 11.5,
            color: "var(--ink-4)",
            textAlign: "center",
            margin: "16px auto 0",
            lineHeight: 1.6,
            maxWidth: 320,
          }}
        >
          Cookies are used to store your admin session securely. Sign out from the menu when you are done.
        </p>
      </div>
    </div>
  );
};

export default LoginPanel;
